<template>
  <div class="wrapper">
      <div id="logo-wrap">
        <transition name="spin" mode="out-in">
            <img 
              :src="logos[currentLogo]" 
              :key="currentLogo" 
              id="logo"
            />
          </transition>
          <Transition><h4 v-show="!success_show">Register</h4></Transition>
      </div>
      <div id="appointment-form">
        <loader v-show="loader_save"/>
        <transition name="fade">
        <form @submit.prevent v-show="!success_show" id="client-reg">
          <fg-input
              type="text"
              label="First Name"
              placeholder="First Name"
              v-model="info.first_name"
              :class="{ error: error_firstname }"
            />
            <fg-input
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                    v-model="info.last_name"
                    :class="{ error: error_lastname }"
            />  
            <fg-input
                    type="text"
                    label="Contact Number"
                    placeholder="Contact Number"
                    v-model="info.contact_number"
                    :class="{ error: error_contact }"
            />
            <div class="form-group mt-4 consent-wrap">
                <label>
                  <input type="checkbox" v-model="info.data_consent" />
                  I agree to the <a href="#" @click.prevent="showConsent">Data Privacy Consent</a>
                </label>
              </div>    
            <div class="btn-wrap">
              <p-button type="info" round @click.native.prevent="addClient" id="add-register" v-show="btn_show">
                    Register
              </p-button> 
            </div>
        </form>
      </Transition>
      <transition name="fade">
        <div id="success" v-show="success_show">
           <h4>Successfully registered!</h4>
           <h4>Welcome to Kagay-an Beauty Lounge! 🌟</h4>
        </div>
      </Transition> 
     
      </div>
    </div>
</template>
<style scoped>
#appointment-form{width:30%; margin:0 auto;  padding: 30px; border-radius: 10px 10px 10px 10px;
-webkit-border-radius: 10px 10px 10px 10px;
-moz-border-radius: 10px 10px 10px 10px;}
#logo-wrap{width:20%; margin:0 auto; margin-bottom: 10px; text-align:center;}
#logo{width:50%; margin-top:50px; margin-bottom: 20px;}
#logo input[type="text"], #logo input[type="password"]{ border: 1px solid;}
#logo label{font-weight: bold!important;}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.mx-datepicker-range {width: 230px;}
.btn-wrap{text-align: center;}
#success h4{text-align: center; }

#logo-wrap h4{color: #bf9b30;}
#add-register{margin-top: 25px;}

#client-reg label{color: #008080!important;}

#client-reg .error{border:1px solid red!important; padding:10px;}

/* transition spin effect */
.spin-enter-active {
  animation: spinIn 0.6s;
}
.spin-leave-active {
  animation: spinOut 0.6s;
}

@keyframes spinIn {
  from { transform: rotateY(180deg); opacity: 0; }
  to { transform: rotateY(0); opacity: 1; }
}
@keyframes spinOut {
  from { transform: rotateY(0); opacity: 1; }
  to { transform: rotateY(-180deg); opacity: 0; }
}

</style>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";
export default {

  components: {
    Loader
  },
  data(){
    return{
      email: '',
      password: '',
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      loader:false,
      info:{
          id:'',
          first_name:'',
          last_name:'',
          contact_number:''
      },
      loader_save: false,
      success_show : false,
      loader_date:false,
      error_firstname:false,
      error_lastname:false,
      error_contact:false,
      btn_show:true,
      logos: [
        require('@/assets/img/logo.png'),
        require('@/assets/img/logo2.png')
      ],
      currentLogo: 0,
      interval: null,
    }
  },
  methods: {
    addClient(){

      let error_count = 0;

      if(this.info.first_name==""){
          error_count++
          this.error_firstname = true
          this.notifyVue('top', 'center','danger','Please enter First Name','ti-hand-stop')
      }else{
        this.error_firstname = false
      }
      
      if(this.info.last_name==""){
        error_count++
        this.error_lastname = true

        this.notifyVue('top', 'center','danger','Please enter Last Name','ti-hand-stop')
      }else{
        this.error_lastname = false
      }
    
      
      if(this.info.contact_number==""){
        error_count++
        this.error_contact = true
        this.notifyVue('top', 'center','danger','Please enter Contact Number','ti-hand-stop')
      }else{
        this.error_contact = false
      }
    

      if(error_count==0){

        this.error_firstname = false
        this.error_lastname = false;
        this.error_contact = false;

      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;

      this.btn_show = false;

            axios.post(api.API_URL+'/register-client/store', {
                    first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Sucessfully Registered!','ti-announcement')
                      self.success_show = true;
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                      self.btn_show = true;
                      
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                           
                          if(error.response.status==400){
                            self.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                              self.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                            this.btn_show = true;
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });

      }
      
      
    },
      notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    }
  },
  mounted(){
      this.interval = setInterval(() => {
        this.currentLogo = (this.currentLogo + 1) % this.logos.length
      }, 5000) // every 5 seconds
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
};
</script>
